/**
 * Platforms in the Agency MFA enforcement matrix.
 *
 * Wire identifiers, not display text: the API says `Web` where the UI says "Webapp". Always map
 * them to a translation constant before rendering.
 */
export enum MfaPlatform {
  WEB = 'Web',
  NATIVE_MOBILE = 'NativeMobile',
}
